import React from 'react';
import './DemoSection.css';

interface DemoSectionProps {
  title: string;
  description: string;
  children: React.ReactNode;
}

interface DemoItemProps {
  title: string;
  children: React.ReactNode;
}

function DemoSection({ title, description, children }: DemoSectionProps) {
  return (
    <section className="demo-section">
      <h2 className="section-title">{title}</h2>
      <p className="section-description">{description}</p>
      <div className="demo-grid">{children}</div>
    </section>
  );
}

DemoSection.Item = function DemoItem({ title, children }: DemoItemProps) {
  return (
    <div className="demo-item">
      <h3 className="demo-item-title">{title}</h3>
      {children}
    </div>
  );
};

export default DemoSection;
